export enum ClaimStatus {
  NotStartedYet = 0,
  InProgress = 1,
  ForClosing = 2,
  Closed = 3,
  AddingToPD = 4,
  DriverCharge = 5,
  ClosedPdLbOpen = 6,
  NeedToOpen = 7,
  RentalNeeded = 8,
  ClosedSubro = 9,
  W8Appraisal = 10,
  SupplementWaiting = 11,
  PaymentWaiting = 12,
  RepairWaiting = 13,
  NaJardi = 14,
  Endorsing = 15,
  InProgressAddingToMs = 16,
  ClosedDenied = 17,
  ClosedPartiallyPaid = 18,
  TrailerInterchange = 19,
}

export const ClaimStatusLabels: Record<ClaimStatus, string> = {
  [ClaimStatus.NotStartedYet]: "Not started yet",
  [ClaimStatus.InProgress]: "In progress",
  [ClaimStatus.ForClosing]: "For closing",
  [ClaimStatus.Closed]: "CLOSED",
  [ClaimStatus.AddingToPD]: "Adding to PD",
  [ClaimStatus.DriverCharge]: "Driver charge",
  [ClaimStatus.ClosedPdLbOpen]: "CLOSED PD LB OPEN",
  [ClaimStatus.NeedToOpen]: "Need to open",
  [ClaimStatus.RentalNeeded]: "Rental needed",
  [ClaimStatus.ClosedSubro]: "Closed/ SUBRO",
  [ClaimStatus.W8Appraisal]: "W8 Appraisal",
  [ClaimStatus.SupplementWaiting]: "Supplement waiting",
  [ClaimStatus.PaymentWaiting]: "Payment waiting",
  [ClaimStatus.RepairWaiting]: "Repair waiting",
  [ClaimStatus.NaJardi]: "NA JARDI",
  [ClaimStatus.Endorsing]: "Endorsing",
  [ClaimStatus.InProgressAddingToMs]: "In progress / adding to MS",
  [ClaimStatus.ClosedDenied]: "Closed / Denied",
  [ClaimStatus.ClosedPartiallyPaid]: "Closed / Partially Paid",
  [ClaimStatus.TrailerInterchange]: "Trailer Interchange",
};

export enum DriverChargedStatus {
  DriverCharged = 0,
  PendingCharge = 1,
  NoCharge = 2,
  InvoicedOnDriver = 3,
}

export const DriverChargedStatusLabels: Record<DriverChargedStatus, string> = {
  [DriverChargedStatus.DriverCharged]: "Driver charged",
  [DriverChargedStatus.PendingCharge]: "Pending charge",
  [DriverChargedStatus.NoCharge]: "No charge",
  [DriverChargedStatus.InvoicedOnDriver]: "Invoiced on driver",
};

export enum AutoLBType {
  AlPd = 0,
  Cargo = 1,
}

export const AutoLBTypeLabels: Record<AutoLBType, string> = {
  [AutoLBType.AlPd]: "AL/PD",
  [AutoLBType.Cargo]: "Cargo",
};

export interface ClaimCompanyDto {
  id: number;
  name: string;
}

export interface LookupDto {
  id: number;
  name: string;
}

export interface ClaimResponseDto {
  id: number;
  dateOfLoss: string;
  city: string | null;
  state: string | null;
  claimCompanyId: number | null;
  companyName: string | null;
  assignedToUserId: number | null;
  assignedToName: string | null;
  driverEmployeeId: number | null;
  driverName: string | null;
  vehicleId: number | null;
  truckName: string | null;
  trailerId: number | null;
  trailerName: string | null;
  description: string | null;
  claimNumber: string | null;
  note: string | null;
  adjusterName: string | null;
  adjusterPhone: string | null;
  adjusterEmail: string | null;
  autoLB: AutoLBType | null;
  policeReportDescription: string | null;
  policeReportDocumentBlobId: number | null;
  totalEstimate: number | null;
  truckEstimate: number | null;
  trailerEstimate: number | null;
  status: ClaimStatus;
  driverCharged: DriverChargedStatus | null;
  createdAt: string;
  updatedAt: string | null;

  documents?: ClaimDocumentDto[];

  // Lookup options for edit form
  availableCompanies?: ClaimCompanyDto[];
  availableDrivers?: LookupDto[];
  availableSafetyUsers?: LookupDto[];
  availableTrucks?: LookupDto[];
  availableTrailers?: LookupDto[];
}

export interface ClaimDocumentDto {
  id: number;
  originalFileName: string;
  fileSizeBytes: number;
  documentCategory: string | null;
  url?: string;
  contentType?: string;
}

export interface CreateClaimDto {
  dateOfLoss: string;
  city?: string | null;
  state?: string | null;
  claimCompanyId?: number | null;
  claimCompanyName?: string | null;
  assignedToUserId?: number | null;
  driverEmployeeId?: number | null;
  vehicleId?: number | null;
  trailerId?: number | null;
  description?: string | null;
  claimNumber?: string | null;
  note?: string | null;
  adjusterName?: string | null;
  adjusterPhone?: string | null;
  adjusterEmail?: string | null;
  autoLB?: AutoLBType | null;
  policeReportDescription?: string | null;
  totalEstimate?: number | null;
  truckEstimate?: number | null;
  trailerEstimate?: number | null;
  status: ClaimStatus;
  driverCharged?: DriverChargedStatus | null;
}

export interface UpdateClaimDto extends CreateClaimDto {}

export interface ClaimFormSubmission {
  dto: CreateClaimDto;
  files?: File[];
  fileCategories?: string[];
  deletedDocumentIds?: number[];
}

export interface ClaimLookupsDto {
  availableCompanies: ClaimCompanyDto[];
  availableDrivers: LookupDto[];
  availableSafetyUsers: LookupDto[];
  availableTrucks: LookupDto[];
  availableTrailers: LookupDto[];
}
